import React from 'react';
import './ShipPlacement.css';

const SHIPS = [
  { type: 'carrier', name: 'Carrier', size: 5 },
  { type: 'battleship', name: 'Battleship', size: 4 },
  { type: 'cruiser', name: 'Cruiser', size: 3 },
  { type: 'submarine', name: 'Submarine', size: 3 },
  { type: 'destroyer', name: 'Destroyer', size: 2 }
];

function ShipPlacement({ player, placingShip, selectedCells, onSelectShip, onPlaceShip, onSetReady, onAutoPlace }) {
  const placedShips = Object.keys(player.ships);
  const allShipsPlaced = placedShips.length === 5;

  return (
    <div className="ship-placement">
      <h2>Ship Placement Phase</h2>

      <div className="ship-list">
        {SHIPS.map(ship => {
          const isPlaced = placedShips.includes(ship.type);
          const isSelected = placingShip === ship.type;

          return (
            <div
              key={ship.type}
              className={`ship-item ${isPlaced ? 'placed' : ''} ${isSelected ? 'selected' : ''}`}
            >
              <button
                onClick={() => onSelectShip(ship.type)}
                disabled={isPlaced}
                className="ship-button"
              >
                {ship.name} ({ship.size} cells)
                {isPlaced && ' ✓'}
              </button>
            </div>
          );
        })}
      </div>

      {!allShipsPlaced && (
        <div className="auto-place-section">
          <button onClick={onAutoPlace} className="btn-auto-place">
            Auto-Place Ships
          </button>
        </div>
      )}

      {placingShip && (
        <div className="placement-controls">
          <p>
            Placing: <strong>{SHIPS.find(s => s.type === placingShip).name}</strong>
          </p>
          <p>
            Selected cells: {selectedCells.length} / {SHIPS.find(s => s.type === placingShip).size}
          </p>
          <div className="button-group">
            <button 
              onClick={onPlaceShip}
              disabled={selectedCells.length !== SHIPS.find(s => s.type === placingShip).size}
              className="btn-primary"
            >
              Place Ship
            </button>
            <button 
              onClick={() => onSelectShip(null)}
              className="btn-secondary"
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {allShipsPlaced && (
        <div className="ready-section">
          <p>All ships placed! Ready to battle?</p>
          <button onClick={onSetReady} className="btn-primary btn-large">
            Ready for Battle!
          </button>
        </div>
      )}

      <div className="placement-tips">
        <h3>Tips:</h3>
        <ul>
          <li>Select a ship from the list above</li>
          <li>Click cells on the board to select them</li>
          <li>Ships must be placed in straight lines (horizontal or vertical)</li>
          <li>Ships cannot overlap</li>
        </ul>
      </div>
    </div>
  );
}

export default ShipPlacement;